
import './ImagesPreviewer.css';
import { useAtom } from 'jotai'; 
import { useSelectedImages } from '../../../data/GlobalStates';
import { useRef } from 'react';
import { TbPhotoUp } from "react-icons/tb";

export default function ImagesPreviewer () {
  
  const [ SelectedImages, setSelectedImages ] = useAtom(useSelectedImages);

  const MAX_IMAGES = 5;
  const safeSelectedImages = Array.isArray(SelectedImages) ? SelectedImages : [];
  const inputRef = useRef(null);
   
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const safeSelectedImages = Array.isArray(SelectedImages) ? SelectedImages : [];

    if (files.length + safeSelectedImages.length > MAX_IMAGES) {
      alert(`Możesz dodać maksymalnie ${MAX_IMAGES} zdjęć.`);
      return;
    }

    const newImages = files.map(file => ({
      file,
      url: URL.createObjectURL(file),
      uploadedUrl: null
    }));

    setSelectedImages(prev => {
      const safePrev = Array.isArray(prev) ? prev : [];
      return [...safePrev, ...newImages];
    })
      if (inputRef.current) {
    inputRef.current.value = '';
  }
  };




  // **Definicja removeImage TUŻ OBOK handleFileChange**
  const removeImage = (index) => {
    setSelectedImages(prev => {
      const safePrev = Array.isArray(prev) ? prev : [];

      if (index < 0 || index >= safePrev.length) {
        return safePrev;
      }

      URL.revokeObjectURL(safePrev[index].url);

      const newImages = [...safePrev];
      newImages.splice(index, 1);

      return newImages;
    });
  };

 

  return (
    <div id='OfferImageUploaderMainContainer'>
      <label htmlFor="OfferMultipleImagesInput" className="custom-upload-button">
          {<TbPhotoUp className='ImagePrevierUploadBtn'/>}
      </label>
      <input
        id='OfferMultipleImagesInput'
        type="file"
        accept="image/*"
        multiple
        onChange={handleFileChange}
        disabled={safeSelectedImages.length >= MAX_IMAGES}
        style={{ display: 'none' }}
        ref={inputRef}
      />
      { safeSelectedImages.length > 0 ? (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          {safeSelectedImages.map(({ url, uploadedUrl }, i) => (
            <div key={i} style={{ position: 'relative' }}>
              <img className='ImageInPreview' src={uploadedUrl || url} alt={`preview ${i}`}/>
              <button className='ImagesUploaderCancelButton' onClick={() => removeImage(i)}>X</button>
            </div>
          ))}
        </div>
      ) : null}
      { safeSelectedImages.length > 0 && (
        <p>{safeSelectedImages.length} / {MAX_IMAGES} zdjęć</p>
      )}
    </div>
  );
}